import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Vue } from 'vue-class-component';
import { Prop } from "vue-property-decorator";
var WIcon = /*#__PURE__*/function (_Vue) {
  function WIcon() {
    var _this;
    _classCallCheck(this, WIcon);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, WIcon, [].concat(args));
    _defineProperty(_this, "icon", void 0);
    _defineProperty(_this, "size", void 0);
    return _this;
  }
  _inherits(WIcon, _Vue);
  return _createClass(WIcon);
}(Vue);
export { WIcon as default };
__decorate([Prop({
  default: ''
})], WIcon.prototype, "icon", void 0);
__decorate([Prop({
  default: '24px'
})], WIcon.prototype, "size", void 0);